var _tspan;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCrazySaleHoursOnly = function SvgCrazySaleHoursOnly(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 26,
    viewBox: "0 0 360 144"
  }, props), /*#__PURE__*/React.createElement("text", {
    "data-name": "24 hours only! Don't Miss Out",
    style: {
      fontSize: 16,
      fill: "#333",
      fontFamily: "&quot"
    },
    transform: "translate(4.151 62.895)scale(3.181)"
  }, "24 hours only!", _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    dy: 19.2
  }, "Don't Miss Out"))));
};
export default SvgCrazySaleHoursOnly;